// extracted by mini-css-extract-plugin
module.exports = {"customInput":"SimpleSearch_customInput__2KdrO"};